import { memo } from 'react';

import { type Board } from '@air/api/types';
import { DropdownMenuItem } from '@air/primitive-dropdown-menu';

import { usePublicShowcaseNavBoardNavigation } from '~/components/v2/components/showcase/hooks/usePublicShowcaseNavBoardNavigation';

export type PublicShowcaseNavMenuBoardItemProps = {
  board: Board;
  /** The page this board is listed under — `null` for Home/the root page. */
  pageId: string | null;
  /** The listing page's slug, or `null` for Home — builds the board's `?page={slug}` route. */
  slug: string | null;
};

/**
 * One board nested (indented) under a page entry in the mobile nav menu. Selecting it shallow-pushes
 * the board route on the public path, or drills the canvas's active board inside the editor — the
 * same decision the desktop dropdown row makes, shared through `usePublicShowcaseNavBoardNavigation`.
 */
export const PublicShowcaseNavMenuBoardItem = memo(({ board, pageId, slug }: PublicShowcaseNavMenuBoardItemProps) => {
  const { handleSelect } = usePublicShowcaseNavBoardNavigation({ boardId: board.id, pageId, slug });

  return (
    <DropdownMenuItem
      className="pl-6"
      data-testid="PUBLIC_COLLECTION_NAV_BOARD_ITEM"
      label={board.title}
      onSelect={handleSelect}
      size="small"
    />
  );
});

PublicShowcaseNavMenuBoardItem.displayName = 'PublicShowcaseNavMenuBoardItem';
